import React from 'react';
import Icon from '@ant-design/icons';

const svg = () =>(
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="能源开放平台"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="管理中心_SDK" transform="translate(-1296.000000, -23.000000)">
        <g id="用户" transform="translate(1288.000000, 16.000000)">
          <g id="Bicon/12/用户/面型" transform="translate(8.000000, 7.000000)">
            <rect
              id="Rectangle-8"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="18"
              height="18"
            ></rect>
            <path
              d="M11.500034,10.5 C11.500034,11.0079009 12.4673967,11.7092744 14.4021219,12.6041204 C14.9735371,12.7573501 15.5091054,12.924057 16.0088267,13.1042412 C16.6035936,13.3186984 17.000034,13.8830665 17.000034,14.5153161 L17.000034,15.5000387 C17.000034,16.3284659 16.3284612,17.0000387 15.500034,17.0000387 L2.25001937,17.0000387 C1.55966214,17.0000387 1.00001702,16.4403936 1.00001702,15.7500364 L1.00001702,14.919847 C1.00001702,14.579877 1.11557741,14.2499929 1.32763527,13.9842654 C1.8700699,13.3045463 2.76086949,12.8097911 4.00003404,12.5 C4.05814721,12.4854717 4.1149197,12.4710392 4.17042245,12.4567071 C5.72349685,11.6319075 6.50003405,10.9796719 6.50003405,10.5 C6.50003405,10.4416825 6.4987587,10.3846403 6.496208,10.3288735 C5.00381477,9.46380671 4.00003405,7.84912613 4.00003405,6 C4.00003405,3.23857625 6.2386103,1 9.00003405,1 L13.000034,1 C13.5523188,1 14.000034,1.44771525 14.000034,2 L14.000034,6 C14.000034,7.84912613 12.9962533,9.46380671 11.5038601,10.3288735 C11.5013094,10.3846403 11.500034,10.4416825 11.500034,10.5 Z"
              id="Combined-Shape"
              fill="currentColor"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const UserIcon = (props) => <Icon component={svg} {...props} />;
